export const IsNightKey = 'IsNightKey';
export const ThemeOptionsKey = 'ThemeOptionsKey';
export const MarketingConsentKey = 'MarketingConsentKey';
export const AppointmentIdKey = (locationId: number) => `AppointmentIdKey_${locationId}`;
export const GiftCardIdKey = (locationId: number) => `GiftCardIdKey_${locationId}`;
export const PreferredLanguageKey = 'PreferredLanguageKey';
/**
 * The grid the server builds availability on. Not the location's "Time slot" setting: that one only decides
 * which of these slots a client is shown, and the server already applies it before we render.
 */
export const TIME_SLOT_GRID_MINUTES = 15;

export const UploadCareConf = {
  cdnUrl: 'https://ucarecdn.com/',
};
